<p-dialog [(visible)]="isDeleteAcknowledgementModal" [style]="{width: '40vw'}" (onHide)="cancel()" [modal]="true">

    <div *ngIf="errorMessages.length > 0">
        <p-messages severity="error">
          <ng-template pTemplate>
            <span class="p-message-icon pi pi-times-circle"></span>
            <span class="p-ml-2">Please correct the following errors.</span>
            <ul>
              <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
            </ul>
          </ng-template>
        </p-messages>
      </div>
    <ng-template pTemplate="header">
        <b>Delete Acknowledgement</b>
    </ng-template>
    <div class="label-text">
        <app-label labelText="You are about to delete an Acknowledgement. This action is not reversible. Do you want to proceed?"></app-label>
    </div>
    <div class="field">
      <bpt-text-input [highlightAllOnFocus]="true" 
        [multiLine]="true" id="reason" label="Reason" 
        [(ngModel)]="reason" [ngClass]="{'error-highlight' : mandatoryFields.reason}">
      </bpt-text-input>
    </div>

    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" id="confirm" (debounceClick)="confirmDeleteAcknowledgement()"></p-button>
        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Cancel" id="cancel" (debounceClick)="cancel()"></p-button>
    </ng-template>
</p-dialog>
